<template>
  <div>
    <div class="block-content relative" v-if="!isOnSettingsMenu">
      <div
        class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer"
        v-if="planBenefit.interactivePresentation &&
          !planBenefit.interactivePresentation.QnAModeration"
        @click="handleCheckNeedUpgradePlan()"
      >
      </div>
      <div
        class="mr-0 form-check form-check-inline relative"
      >
        <div
          class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer"
          v-if="planBenefit.interactivePresentation &&
            !planBenefit.interactivePresentation.QnAModeration"
          @click="handleCheckNeedUpgradePlan()"
        >
        </div>
        <div
          class="custom-control custom-checkbox remove-css-disable"
          @click.capture="openModalUpgrade"
        >
          <input
            type="checkbox"
            class="custom-control-input"
            id="check-qna-moderation"
            :disabled="isDisableQnaModeration"
            v-model="$store.state.presentation.isModerationMode"
            @change="handleCheckBox()"
          >

          <label
            class="custom-control-label"
            for="check-qna-moderation"
          >
            {{ $i18nPresenter.t("Moderate audience’s questions") }}
          </label>
          <IconNeedUpgradePlan
            ref="iconNeedUpgradePlanComponentQnAModeration"
            :noPermission="planBenefit.interactivePresentation &&
              !planBenefit.interactivePresentation.QnAModeration"
            :defaultTooltip="$i18nPresenter.t(
              `Approve or dismiss questions before they are shown on the presenter's screen.`
            )"
            left="-160px"
            :upgradePlan="planBenefit.interactivePresentation.QnAModeration_planName"
            featureName="QnAModeration"
            v-if="planBenefit.interactivePresentation"
          />
        </div>

        <QnAModerationLink v-if="presentation.isModerationMode" />
      </div>
    </div>
    <!-- Moderation on Header Settings -->
    <div
      v-if="isOnSettingsMenu"
      class="settings-moderation-wrapper relative"
      :class="settingsModerationWrapperClass"
    >
      <div
        class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer"
        v-if="planBenefit.interactivePresentation &&
          !planBenefit.interactivePresentation.QnAModeration"
        @click="handleCheckNeedUpgradePlan()"
      ></div>
      <div @click.capture="openModalUpgrade" class="inline-block relative">
        <aha-checkbox
          id="settings-check-qna-moderation"
          v-model="$store.state.presentation.isModerationMode"
          :disabled="isDisableQnaModeration"
          @change="handleCheckBox()"
          class="mb-0 remove-css-disable"
        >
          <span>{{ $i18nPresenter.t("Moderate audience’s questions") }}
            <span v-if="!canUseNewTooltip">
              <IconNeedUpgradePlan
                ref="iconNeedUpgradePlanComponentQnAModeration"
                :noPermission="planBenefit.interactivePresentation &&
                  !planBenefit.interactivePresentation.QnAModeration"
                :defaultTooltip="$i18nPresenter.t(
                  `Approve or dismiss questions before they are shown on the presenter's screen.`
                )"
                left="-160px"
                :upgradePlan="planBenefit.interactivePresentation.QnAModeration_planName"
                featureName="QnAModeration"
                v-if="planBenefit.interactivePresentation"
              />
            </span>
            <span v-else>
              <UpgradeIcon
                ref="iconNeedUpgradePlanComponentQnAModeration"
                :noPermission="planBenefit.interactivePresentation &&
                  !planBenefit.interactivePresentation.QnAModeration"
                :defaultTooltip="$i18nPresenter.t(
                  `Approve or dismiss questions before they are shown on the presenter's screen.`
                )"
                :upgradePlan="planBenefit.interactivePresentation.QnAModeration_planName"
                featureName="QnAModeration"
                v-if="planBenefit.interactivePresentation"
              />
            </span>
          </span>
        </aha-checkbox>
      </div>
      <QnAModerationLink v-if="$store.state.presentation.isModerationMode" />
    </div>
    <!-- End of Moderation on Header Settings -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import QnAModerationLink from '@/components/presentations/QnAModerationLink.vue'
import QnAModerationLinkContainer from '@/containers/qna-moderation/QnAModerationLink'
import IconNeedUpgradePlan from '@/components-v2/my-plan/IconNeedUpgradePlan.vue'
import UpgradeIcon from '@/components-v2/my-plan/UpgradeIcon.vue'

export default {
  components: {
    QnAModerationLink: QnAModerationLinkContainer(QnAModerationLink),
    IconNeedUpgradePlan,
    UpgradeIcon,
  },
  props: {
    isOnSettingsMenu: {
      type: Boolean,
      default: false,
    },
    handleCheckBoxModeration: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      ctaUpgradePresentationMorderation: false,
    }
  },
  computed: {
    ...mapState({
      planBenefit: (state) => state.planBenefit,
      presentation: (state) => state.presentation,
    }),
    ...mapGetters('featureToggles', ['canUseNewTooltip']),
    moderationToolTip() {
      return this.$i18nPresenter.t("Use the link provided to approve and dismiss questions before they are shown on the presenter's screen")
    },
    isWhiteLabel() {
      return this.$store.state.plan.group === 'white-label'
    },
    isProPlan() {
      return this.$store.state.plan.group === 'pro'
    },
    isEduLarge() {
      return this.$store.state.plan.type == 'edu-large-yearly'
    },
    isBeforeCurrentPeriodStart() {
      return this.$store.state.currentUser.isBeforeCurrentPeriodStart
    },
    isPlanFree() {
      return this.$store.state.plan && this.$store.state.plan.group === 'free'
    },
    isDisableQnaModeration() {
      return this.planBenefit.interactivePresentation && !this.planBenefit.interactivePresentation.QnAModeration
    },
    isShowTooltip() {
      return this.isBeforeCurrentPeriodStart ? !(this.isProPlan || this.isWhiteLabel || this.isEduLarge) : false
    },
    bindingCheckbox: {
      get() {
        if (this.isShowTooltip) {
          return false
        }
        return this.presentation.isModerationMode
      },
    },
    settingsModerationWrapperClass() {
      return this.presentation.isModerationMode ? 'mb-3' : 'mb-2'
    },
  },
  methods: {
    clickOutsideUpPresentationMorderation() {
      this.ctaUpgradePresentationMorderation = false
    },
    openModalUpgrade() {
      if (this.isShowTooltip) {
        this.ctaUpgradePresentationMorderation = true
      }
    },
    handleCheckBox() {
      if (this.isShowTooltip) {
        this.openModalUpgrade()
        return
      }
      this.handleCheckBoxModeration()
    },
    handleCheckNeedUpgradePlan() {
      if (this.planBenefit.interactivePresentation && !this.planBenefit.interactivePresentation.QnAModeration) {
        this.$refs.iconNeedUpgradePlanComponentQnAModeration.toggleTooltip()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss-v2/variables.scss';

.settings-moderation-wrapper {
  &.disabled {
    color: $disabled-text;
    @apply italic;
    ::v-deep .checkbox-component-wrapper {
      background-color: $disabled-input;
    }
  }
}
.upgrade-arrow {
  width: 0;
  height: 0;
  border-width: 0 8px 8px 8px;
  border-color: transparent transparent rgba(40, 46, 62, 1) transparent;
  border-style: solid;
  position: absolute;
  z-index: 1;
  top: 1.6rem;

  &.upgrade-arrow_presentation {
    left: calc(50% - 47px);
  }

  &.upgrade-arrow_slide {
    left: 10%;
  }
}
</style>
